module.exports = __webpack_public_path__ + "static/mr-concert-performance-35-a099347e1de864a01f033dc345b87963.jpg";